<template>
  <teleport to="body">
    <div v-if="open" class="modal" @click.self.prevent="$emit('close')">
      <div class="sat-container">
        <font-awesome-icon icon="fa-xmark" class="exit" @click="$emit('close')" />
        <h2>Items to Confirm</h2>
        <div v-for="product in products" :key="product" class="product-item">
          <img v-if="product.image" :src="product.image" alt="product image" />
          <div class="text">
            <p>
              <span v-if="product.quantity > 1">{{ product.quantity }} x </span>{{ product.name }}
            </p>
            <div v-for="modifier in product.modifier_list" :key="modifier" class="modifier-item">
              <p>
                {{ modifier.name }} <span v-if="modifier.price > 0">- ${{ modifier.price }}</span>
              </p>
            </div>
            <CurrencyFormatter :value="product.price" :currency="currency"/>
          </div>
        </div>
        <div class="btns">
          <button @click="$emit('setTab')">Confirm</button>
          <button @click="$emit('payTab')">Pay Tab</button>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script>
  import { CurrencyFormatter  } from '@monolith/components';
  import { mapGetters } from "vuex";
export default {
  name: "SatelliteModal",
  components: {
    CurrencyFormatter,
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Object,
      default: () => ({}),
    },
  },

  emits: ["close", "setTab", "payTab"],
  data() {
    return {};
  },
  methods: {
    // Component methods
  },
  computed: {
    ...mapGetters({
      currency: "currency",
    })
  }
};
</script>

<style scoped lang="scss">
@use "@monolith/styles";

.modal {
  .sat-container {
    background-color: var(--secondary-colour);
    border-radius: 1rem;
    padding: 1rem;
    box-shadow: var(--box-shadow);
    .product-item {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 1rem;
      .text {
        display: flex;
        flex-direction: column;
        margin: 1rem;
        p {
          margin: 0;
        }
      }
      img {
        width: 7rem;
        border-radius: 1rem;
      }
    }
    .btns {
      display: flex;
      justify-content: center;
      button {
        margin: 0.5rem;
        border: none;
        border-radius: 0.5rem;
        padding: 1rem 4rem;
        background-color: var(--action-colour);
        color: var(--secondary-text-colour);
        box-shadow: var(--box-shadow);
        cursor: pointer;
      }
    }
  }
}
</style>
